
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/chemical-reactions",
      function () {
        return require("private-next-pages/archive/chemical-reactions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/chemical-reactions"])
      });
    }
  